import { useQuery } from 'react-query';

import { CommonAttachmentService } from '../../api';
import { SessionType } from '../../api/Attachment/getFilesUploadLinksBySessionIdCommand';

export const useQrCodeImportModal = ({
  id,
  sellerId,
}: {
  id?: string;
  sellerId: string;
}) => {
  const { data, isLoading } = useQuery(
    ['getFileAttachmentUploadLinkFromControlCommand', { id, sellerId }],
    async () => {
      const response =
        await CommonAttachmentService.getFilesUploadLinksBySessionIdCommand({
          sellerId,
          type: SessionType.SINGLE_FILE,
        });

      if (response.failure) {
        return undefined;
      }

      return response.value;
    },
    {
      refetchOnMount: 'always',
    },
  );

  return {
    uploadQrCode: data?.uploadQrCode,
    uploadUrl: data?.uploadUrl,
    isLoading,
    sessionId: data?.sessionId,
  };
};
